"use strict";
import {http} from '../../core';
import Config from "../../app.config";
const RequestService = http.create();


export default {
    //事件管理-事件完成数统计-饼状
    getEventComplete(params){
        return  RequestService.get('event/complete',params)
    }
}
